import { styled } from "@mui/material";

export const GreetingsRoot = styled("div")`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    height: 100%;
    margin: auto;
    cursor: pointer;
    position: relative;
    padding-bottom: 64px;

    h1 {
        font-weight: bold;
    }
`;

export default GreetingsRoot;
